import { jwtDecode } from 'jwt-decode';
import { $authHost, $host } from '.';

export const createUser = async (userData) => {
    try {
        const { data } = await $host.post('/users/', userData);
        return data;
    } catch (e) {
        console.error('Creating user failed:', e);
    }
};

export const login = async (login, password) => {
    const loginData = {
        username: login,
        login: login,
        password: password,
    };
    const { data } = await $host.post('/users/login/', loginData);
    const token = data.access_token;
    localStorage.setItem('access_token', token);
    return jwtDecode(token);
};

// Получить пользователя по ID
export const getOneUser = async (userId) => {
    const { data } = await $authHost.get(`/users/${userId}/`);
    return data;
};

// Получить информацию о текущем пользователе
export const getCurrentUser = async () => {
    const { data } = await $authHost.get('/users/me/');
    // **Ответ (200 OK):** Аналогично GET /api/users/ (один объект)
    return data;
};

// Получить список пользователей
export const getUsers = async () => {
    const { data } = $authHost.get('/users/');
    // **Ответ (200 OK):**
    // ```json
    // [
    //   {
    //     "id": 1,
    //     "email": "user@example.com",
    //     "phone": "+79991234567",
    //     "username": "user123",
    //     "last_name": "Иванов",
    //     "first_name": "Иван",
    //     "patronymic": "Петрович",
    //     "full_name": "Иванов Иван Петрович",
    //     "sex": "M",
    //     "patient": null,
    //     "employee": {
    //       "id": 1,
    //       "user_id": 1,
    //       "post": 1,
    //       "medical_institution_title": "Городская больница №1",
    //       "medical_institution_address": "ул. Ленина, д. 15"
    //     },
    //     "date_joined": "2024-01-15T10:30:00Z",
    //     "last_login": "2024-01-15T15:45:00Z"
    //   }
    // ]
    // ```
    return data;
};

// Обновить пользователя
export const updateUser = async (userId) => {
    // **Запрос (PATCH):**
    // ```json
    // {
    //   "first_name": "Новое имя",
    //   "email": "new@example.com"
    // }
    // ```
    const { data } = await $authHost.put(`/users/${userId}/`);
    return data;
};
